<template>
  <div class="">
    <div class="address-item"  @click="openModal()">
      <div class="slice-hover" :class="{active: isMobile()}" :data-link-alt='getHoverLabel()'>
        <span  class="sh-native d-flex" >
          <span class="address-item-item" v-for="address in addressesArray" v-text="address.name"></span>
        </span>
      </div>

    </div>
    <div class="bd-modal-backdrop" v-show="openedModal" @click="openedModal=!openedModal"></div>
    <div class="bd-modal addresses-modal" v-show="openedModal">
      <div class="bd-modal-close" @click="openedModal=!openedModal"></div>
      <div class="bd-modal-title">Адреса на карте</div>
      <div class="addresses-toggle">
        <div v-for="address in addressesArray" :class="{active: address.id == activeAddress}" v-text="address.name" @click="setActiveAddress(address.id)"></div>
      </div>
      <div>
        <div id="contact-map-novosibirsk" class="contact-map" v-if="city == 'novosibirsk'"></div>
        <div id="contact-map-krasnoyarsk" class="contact-map" v-if="city == 'krasnoyarsk'"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "header-addresses",
  props: ['addressesArray'],
  data() {
    return {
      map: null,
      openedModal: false,
      city: null,
      activeAddress: null,
      mapLoaded: false,
      coords: {
        'krasnoyarsk':{
          1: [56.00996375715832,92.87100244180293],
          2: [56.04449306870379,92.92246049999997],
          3: [56.050510, 92.903570],
        },
        'novosibirsk':{
          1: [55.039232,82.961170],
        }
      }
    }
  },
  mounted() {
    this.city = this.addressesArray[0].city
    this.activeAddress = this.addressesArray[0].id

  },
  methods: {
    isMobile(){
      return window.isMobile()
    },
    getHoverLabel(){
      return (this.isMobile())?'адреса на карте':'показать адреса на карте'
    },
    openModal(){
      this.openedModal = true
      if(!this.mapLoaded)
        this.contact_map_init(this.city)
    },
    setActiveAddress(id){
      this.activeAddress = id;
      this.map.setCenter(this.coords[this.city][this.activeAddress])
    },
    contact_map_init(city) {
      this.mapLoaded = true
      let myMap;
      switch (city) {
        case 'krasnoyarsk':
          this.map = new window.ymaps.Map('contact-map-krasnoyarsk', {
            center: this.coords[this.city][this.activeAddress],
            zoom: 15
          });
          let officeMarksa = new window.ymaps.Placemark(
              [56.00996375715832,92.87100244180293],
              {
                iconCaption: 'Анекс Тур - офис в Центре',
                balloonContent: 'ул. Карла Маркса, 95. ТЦ «Евразия», 1 этаж<br>' +
                    '<a href="tel:+73912805088">+7 (391) 216-33-34</a><br>' +
                    '<a href="mailto:info-anextur@yandex.ru">info-anextur@yandex.ru</a><br>' +
                    'Пн-Пт 10:00 - 20:00<br>' +
                    'Сб-Вс 11:00 - 19:00'
              },
              {
                preset: 'islands#redBeachIcon'
              });
          this.map.geoObjects.add(officeMarksa);
          let officeAviator = new window.ymaps.Placemark(
              [56.04449306870379,92.92246049999997],
              {
                iconCaption: 'Анекс Тур - офис на Взлетке',
                balloonContent: 'ул. Авиаторов, 5. ТК «Авиатор», 1 этаж<br>' +
                    '<a href="tel:+73912805088">+7 (391) 216-33-34</a><br>' +
                    '<a href="mailto:info-anextur@yandex.ru">info-anextur@yandex.ru</a><br>' +
                    'Пн-Пт 10:00 - 20:00<br>' +
                    'Сб-Вс 11:00 - 19:00'
              },
              {
                preset: 'islands#darkGreenBeachIcon'
              });
          this.map.geoObjects.add(officeAviator);
          let officePlaneta = new window.ymaps.Placemark(
              [56.050510, 92.903570],
              {
                iconCaption: 'Анекс Тур - ТРЦ Планета',
                balloonContent: 'ул. Авиаторов, 5. ТК «Авиатор», 1 этаж<br>' +
                    '<a href="tel:+73912805088">+7 (391) 216-33-34</a><br>' +
                    '<a href="mailto:info-anextur@yandex.ru">info-anextur@yandex.ru</a><br>' +
                    'Пн-Пт 10:00 - 20:00<br>' +
                    'Сб-Вс 11:00 - 19:00'
              },
              {
                preset: 'islands#darkGreenBeachIcon'
              });
          this.map.geoObjects.add(officePlaneta);
          break;
        case 'novosibirsk':
          this.map = new window.ymaps.Map('contact-map-novosibirsk', {
            center: this.coords[this.city][this.activeAddress],
            zoom: 15
          });
          let officeSibMoll = new window.ymaps.Placemark(
              [55.039232,82.961170],
              {
                iconCaption: 'Анекс Тур',
                balloonContent: 'ул. Фрунзе, 238. ТРЦ «Сибирский молл», вход со стороны улицы Фрунзе<br>' +
                    '<a href="tel:+73833829990">+7 (383) 382-9990</a><br>' +
                    '<a href="mailto:info-anextur@yandex.ru">info-anextur@yandex.ru</a><br>' +
                    'Пн-Вс 10:00 - 20:00'
              },
              {
                preset: 'islands#redBeachIcon'
              });
          this.map.geoObjects.add(officeSibMoll);
          break;
      }
    }
  },
}
</script>
